const baseURL = "https://rr-api.moshimoshi.cloud/api/rr";
export default baseURL;
